const ALLOWED_PROTOCOLS = ['https:', 'http:'];

/**
 * Sanitizes an image URL, only allowing http/https protocols.
 * Returns null for invalid or potentially malicious URLs.
 */
export function sanitizeImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  try {
    const parsed = new URL(url);
    return ALLOWED_PROTOCOLS.includes(parsed.protocol) ? url : null;
  } catch {
    return null;
  }
}
